import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var Es = function Es(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#DD172C",
    d: "M0 3.2h16v1.6H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD133",
    d: "M0 4.8h16v6.4H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.267 7.2h1.066V8H4.267v-.8z",
    fill: "#FFEDB1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5.6a.8.8 0 00-.8.8h2.4a.8.8 0 00-.8-.8H4zm-2 .8a.4.4 0 00-.4.4v2.4a.4.4 0 10.8 0V6.8a.4.4 0 00-.4-.4zm1.881.533a.667.667 0 00-.665.719l.116 1.493a1.071 1.071 0 002.136 0l.116-1.493a.667.667 0 00-.665-.719H3.881zm2.52-.133a.4.4 0 11.8 0v2.4a.4.4 0 01-.8 0V6.8zM3.8 8.48H5V9a.6.6 0 01-1.2 0v-.52zm1.4-1.04H3.6l.16.56h1.28l.16-.56z",
    fill: "#A41517"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DD172C",
    d: "M0 11.2h16v1.6H0z"
  }));
};
export default Es;